module.exports = {
  defaultTitle: 'CRISWEB.ME',
  logo: 'https://www.crisweb.me/img/favicon-32x32.png',
  author: 'CRISWEB.ME',
  url: 'https://www.crisweb.me/',
  legalName: 'CRISWEB.ME',
  defaultDescription: 'Somos una empresa de desarrollo de software enfcada al desarollo de: páginas web, aplicaciones web, moviles, videojuegos serios.',
  socialLinks: {
    twitter: 'http://www.twitter.com/',
    github: 'https://github.com/',
    linkedin: 'https://www.linkedin.com/in/',
    instagram: 'https://instagram.com/',
    youtube: 'https://www.youtube.com/user/',
    google: 'https://plus.google.com/',
  },
  googleAnalyticsID: 'UA-204681110-1',
  themeColor: '#6b63ff',
  backgroundColor: '#6b63ff',
  social: {
    facebook: '',
    twitter: '@',
  },
  address: {
    city: 'Quito',
    region: 'Pichincha',
    country: 'Ecuador',
    zipCode: '17066',
  },
  contact: {
    email: 'info.crisweb@gmail.com',
    phone: 'phone-number',
  },
  foundingDate: '2021',
};
